module.exports = __webpack_public_path__ + "static/media/Table_Games_Purple@3x.cc1b74cb.png";